import React, { useEffect, useState } from "react";

const CheckoutCard = ({ orderId = "ORDER_12345", amount = 1.0 }) => {
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!window.MercadoPago) return;

    // --- Chave pública baseada no ambiente ---
    let PUBLIC_KEY;
    if (process.env.NODE_ENV === "production") {
      PUBLIC_KEY = process.env.REACT_APP_MP_PUBLIC_KEY;
    } else {
      PUBLIC_KEY = process.env.REACT_APP_MP_PUBLIC_KEY_TEST;
    }

    if (!PUBLIC_KEY) {
      console.error("⚠️ PUBLIC_KEY do Mercado Pago não definida.");
      return;
    }

    const mp = new window.MercadoPago(PUBLIC_KEY, { locale: "pt-BR" });

    const cardForm = mp.cardForm({
      amount: String(amount),
      iframe: true,
      form: {
        id: "form-checkout",
        cardNumber: { id: "form-checkout__cardNumber", placeholder: "Número do cartão" },
        expirationDate: { id: "form-checkout__expirationDate", placeholder: "MM/YY" },
        securityCode: { id: "form-checkout__securityCode", placeholder: "Código de segurança" },
        cardholderName: { id: "form-checkout__cardholderName", placeholder: "Titular do cartão" },
        issuer: { id: "form-checkout__issuer", placeholder: "Banco emissor" },
        installments: { id: "form-checkout__installments", placeholder: "Parcelas" },
        identificationType: { id: "form-checkout__identificationType", placeholder: "Tipo de documento" },
        identificationNumber: { id: "form-checkout__identificationNumber", placeholder: "Número do documento" },
        cardholderEmail: { id: "form-checkout__cardholderEmail", placeholder: "E-mail" },
      },
      callbacks: {
        onFormMounted: (err) => {
          if (err) console.warn("Erro ao montar formulário:", err);
          else console.log("Formulário montado com sucesso!");
        },
        onFetching: () => {
          const progressBar = document.querySelector(".progress-bar");
          progressBar.removeAttribute("value");
          return () => progressBar.setAttribute("value", "0");
        },
        onSubmit: async (event) => {
          event.preventDefault();
          setStatus("Processando pagamento...");
          setError("");

          try {
            const data = cardForm.getCardFormData();

            const fullName = data.cardholderName || "";
            const firstName = fullName.split(" ")[0] || "";
            const lastName = fullName.split(" ").slice(1).join(" ") || "";

            const payload = {
              token: data.token,
              transaction_amount: Number(data.amount),
              installments: Number(data.installments),
              payment_method_id: data.paymentMethodId,
              issuer_id: data.issuerId,
              description: "Bebilogo App",
              external_reference: orderId,
              notification_url: "https://gestor.bebilogo.com.br/api-mercadopago/webhooks",
              payer: {
                email: data.cardholderEmail,
                first_name: firstName,
                last_name: lastName,
                identification: {
                  type: data.identificationType,
                  number: data.identificationNumber,
                },
                phone: { area_code: "91", number: "983744682" },
                address: {
                  zip_code: "66620270",
                  street_name: "Rua Capanema",
                  street_number: "5",
                  neighborhood: "Marambaia",
                  city: "Belém",
                  federal_unit: "PA",
                },
              },
              items: [
                {
                  id: "001",
                  title: "Produtos Teste",
                  description: "Bebida gelada e aperitivos",
                  category_id: "bebidas",
                  quantity: 1,
                  unit_price: Number(data.amount),
                },
              ],
            };

            const res = await fetch(
              "https://gestor.bebilogo.com.br/api-mercadopago/pagamento",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              }
            );

            const result = await res.json();
            console.log("✅ Resposta backend:", result);
            setStatus("Pagamento realizado com sucesso!");
          } catch (err) {
            console.error("Erro no pagamento:", err);
            setError(err.message || "Erro ao processar pagamento.");
            setStatus("");
          }
        },
      },
    });
  }, [amount, orderId]);

  const containerStyle = { height: 40, border: "1px solid #ccc", borderRadius: 4, padding: "0 8px", display: "flex", alignItems: "center", marginBottom: 12 };
  const inputStyle = { width: "100%", height: 36, padding: "0 8px", border: "1px solid #ccc", borderRadius: 4, marginBottom: 12 };
  const selectStyle = { width: "100%", height: 36, padding: "0 8px", border: "1px solid #ccc", borderRadius: 4, marginBottom: 12, backgroundColor: "#fff" };
  const buttonStyle = { width: "100%", padding: "10px", borderRadius: 4, border: "none", backgroundColor: "#1890ff", color: "#fff", fontWeight: "bold", cursor: "pointer", marginTop: 12 };
  const progressStyle = { width: "100%", marginTop: 10 };

  return (
    <div style={{ maxWidth: 600, margin: "20px auto", padding: 20, background: "#fff", borderRadius: 8, boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
      <h2>Pagamento com Cartão</h2>

      <form id="form-checkout">
        <div id="form-checkout__cardNumber" className="container" style={containerStyle}></div>
        <div id="form-checkout__expirationDate" className="container" style={containerStyle}></div>
        <div id="form-checkout__securityCode" className="container" style={containerStyle}></div>

        <input type="text" id="form-checkout__cardholderName" style={inputStyle} placeholder="Titular do cartão" />
        <select id="form-checkout__issuer" style={selectStyle}></select>
        <select id="form-checkout__installments" style={selectStyle}></select>
        <select id="form-checkout__identificationType" style={selectStyle}></select>
        <input type="text" id="form-checkout__identificationNumber" style={inputStyle} placeholder="Número do documento" />
        <input type="email" id="form-checkout__cardholderEmail" style={inputStyle} placeholder="E-mail" />

        <button type="submit" id="form-checkout__submit" style={buttonStyle}>Pagar</button>
        <progress value="0" className="progress-bar" style={progressStyle}></progress>
      </form>

      {status && <p style={{ color: "green", marginTop: 10 }}>{status}</p>}
      {error && <p style={{ color: "red", marginTop: 10 }}>{error}</p>}
    </div>
  );
};

export default CheckoutCard;
